import React from 'react';
import { node } from 'prop-types';
import './with-divider.m.css';

const TitleWithDivider = ({ children }) => (
  <div styleName="wrapper">
    <div styleName="title" className="title">{children}</div>
    <div styleName="divider" className="divider" />
  </div>
);

TitleWithDivider.propTypes = {
  children: node.isRequired
};

export default TitleWithDivider;
